import type { HTMLAttributes } from 'react'
import { formatElevenLabsCost } from './adminCosts'

interface ElevenLabsCostProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'children' | 'title'> {
  credits: number | undefined
  usd?: number
  rate?: number
  unit?: 'short' | 'long'
  sourceComplete?: boolean
}

/** Единое представление кредитов ElevenLabs и их оценки по тарифу API. */
export function ElevenLabsCost({
  credits,
  usd,
  rate,
  unit,
  sourceComplete,
  ...props
}: ElevenLabsCostProps) {
  const presentation = formatElevenLabsCost({ credits, usd, rate, unit, sourceComplete })

  return (
    <span
      {...props}
      title={presentation.title}
      data-cost-complete={presentation.complete ? 'true' : 'false'}
    >
      {presentation.text}
    </span>
  )
}
